import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, Tab, Tabs } from "react-bootstrap";
import ComponentBarChart from "./ComponentBarChart";
import ComponentPieChart from "./ComponentPieChart";

const ModalDetailsVisiteur = (props) => {
  const { t } = useTranslation();
  const { show, handleClose, logs, intervalle } = props;

  const [tabKey, setTabKey] = useState("frequentation");

  const [labelsFrequentation, setLabelsFrequentation] = useState([]);
  const [datasetsFrequentation, setDatasetsFrequentation] = useState([]);

  const [labelsPagesConsultees, setLabelsPagesConsultees] = useState([]);
  const [datasetsPagesConsultees, setDatasetsPagesConsultees] = useState([]);

  const [datasetsFrequentationHoraire, setDatasetsFrequentationHoraire] = useState([]);

  const formateDate = (date) => {
    const elem = date.split("-");
    const annee = elem[0];
    const mois = elem[1];
    const jour = elem[2];
    const dateCalculee = jour + "/" + mois + "/" + annee;
    return dateCalculee;
  };

  const calculeDateAnterieure = (intervalle) => {
    var date = new Date();
    date.setDate(date.getDate() - intervalle);
    var dateCalculee =
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1 < 10 ? "0" : "") +
      (date.getMonth() + 1) +
      "-" +
      (date.getDate() < 10 ? "0" : "") +
      date.getDate();

    return dateCalculee;
  };

  /* FONCTION PERMETTANT LE CALCUL DE LA FREQUENTATION JOURNALIERE/HEBDO/MENSUELLE */
  const calculFrequentation = (datas) => {
    const labelsFrequentationTemp = [];
    let dateEnCours = "";
    let datasFrequentationGlobaleNavigateur = [];
    let datasFrequentationGlobaleApplication = [];

    for (var i = 0; i <= intervalle; i++) {
      dateEnCours = calculeDateAnterieure(i);
      // on rajoute le label dans le tableau des labels
      labelsFrequentationTemp.unshift(formateDate(dateEnCours));

      // pour cette date là on va extraire tous ls trackings (createdAt = dateEnCours)
      const connexionsGlobalesDuJour = datas.filter(
        (item) => item.createdAt.indexOf(dateEnCours) !== -1 // eslint-disable-line no-loop-func
      );

      // pour cette date, on va compter le nombre de sessions ouvertes par X users (si les gens sont venus 20 fois on compte 20)
      // car à chaque visite le traceurNavigation change
      const connexionsGlobalesNavigateur = [
        ...new Set(
          connexionsGlobalesDuJour
            .filter((item) => item.device === "navigateur")
            .map((data) => data.traceurNavigation)
        ),
      ];

      datasFrequentationGlobaleNavigateur.unshift(connexionsGlobalesNavigateur.length);

      const connexionsGlobalesApplication = [
        ...new Set(
          connexionsGlobalesDuJour
            .filter((item) => item.device === "application")
            .map((data) => data.traceurNavigation)
        ),
      ];
      datasFrequentationGlobaleApplication.unshift(connexionsGlobalesApplication.length);
    }

    setDatasetsFrequentation([
      {
        label:
          t("admin.PageAdminStatistiques.nbrVisites") +
          t("admin.PageAdminStatistiques.depuisApplication"),
        data: datasFrequentationGlobaleApplication,
        backgroundColor: "rgba(255, 102, 0, 1)",
      },
      {
        label:
          t("admin.PageAdminStatistiques.nbrVisites") +
          t("admin.PageAdminStatistiques.depuisNavigateur"),
        data: datasFrequentationGlobaleNavigateur,
        backgroundColor: "rgba(66, 74,96, 1)",
      },
    ]);
    setLabelsFrequentation(labelsFrequentationTemp);
  };

  /* FONCTION PERMETTANT LE CALCUL DE LA FREQUENTATION  DES PAGES CONSULTEES */
  const calculPagesConsultees = (datas) => {
    let labelsPagesConsulteesTemp = [];
    let datasetsPagesConsulteesTemp = [];
    let connexionsGlobalesSurIntervalle = [];
    let dateEnCours = "";

    for (var i = 0; i <= intervalle; i++) {
      dateEnCours = calculeDateAnterieure(i);
      // pour cette date là on va extraire tous ls trackings (createdAt = dateEnCours)
      const connexionsGlobalesDuJour = datas.filter(
        (item) => item.createdAt.indexOf(dateEnCours) !== -1 // eslint-disable-line no-loop-func
      );
      connexionsGlobalesSurIntervalle = connexionsGlobalesDuJour.concat(
        connexionsGlobalesSurIntervalle
      );
    }

    // on va identifier les noms de pages uniques consultées
    labelsPagesConsulteesTemp = [
      ...new Set(connexionsGlobalesSurIntervalle.map((data) => data.title)),
    ];
    // pour chaque page consultée,on va compter le nombre de fois ou elle apparait dans les logs
    labelsPagesConsulteesTemp.forEach((titrePage) => {
      let nbrVues = connexionsGlobalesSurIntervalle.filter((item) => item.title === titrePage);
      datasetsPagesConsulteesTemp.push(nbrVues.length);
    });
    setLabelsPagesConsultees(labelsPagesConsulteesTemp);
    setDatasetsPagesConsultees(datasetsPagesConsulteesTemp);
  };

  /* FONCTION PERMETTANT LE CALCUL DE LA FREQUENTATION HORAIRE*/
  const calculFrequentationHoraire = (datas) => {
    let heure = "";
    let horaireTemp = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

    datas.forEach((element) => {
      heure = new Date(element.createdAt).getHours();
      horaireTemp[heure]++;
    });
    setDatasetsFrequentationHoraire([
      {
        label: t("admin.PageAdminStatistiques.nbrVisites"),
        data: horaireTemp,
        backgroundColor: "rgba(66, 74,96, 1)",
      },
    ]);
  };

  useEffect(() => {
    if (logs) {
      calculFrequentation(logs);
      calculPagesConsultees(logs);
      calculFrequentationHoraire(logs);
    }
  }, [logs]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {show && (
        <Modal size="lg" show={show} onHide={handleClose} className="modalPersonne">
          <Modal.Header closeButton>
            <Modal.Title>{t("admin.PageAdminStatistiques.modalVisiteurTitle")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Tabs
              defaultActiveKey={tabKey}
              className="mb-3"
              onSelect={(selectedKey) => {
                setTabKey(selectedKey);
              }}
            >
              <Tab eventKey="frequentation" title={t("admin.PageAdminStatistiques.frequentation")}>
                <ComponentBarChart
                  titleGraphe={t("admin.PageAdminStatistiques.frequentation")}
                  labels={labelsFrequentation}
                  datasets={datasetsFrequentation}
                  stacked="true"
                />
              </Tab>
              <Tab eventKey="horaire" title={t("admin.PageAdminStatistiques.horaire")}>
                <ComponentBarChart
                  titleGraphe={t("admin.PageAdminStatistiques.horaire")}
                  labels={[
                    "0h",
                    "1h",
                    "2h",
                    "3h",
                    "4h",
                    "5h",
                    "6h",
                    "7h",
                    "8h",
                    "9h",
                    "10h",
                    "11h",
                    "12h",
                    "13h",
                    "14h",
                    "15h",
                    "16h",
                    "17h",
                    "18h",
                    "19h",
                    "20h",
                    "21h",
                    "22h",
                    "23h",
                  ]}
                  datasets={datasetsFrequentationHoraire}
                />
              </Tab>
              <Tab
                eventKey="pagesConsultees"
                title={t("admin.PageAdminStatistiques.pagesConsultees")}
              >
                <div style={{ maxWidth: "500px", margin: "auto" }}>
                  <ComponentPieChart
                    titleGraphe={t("admin.PageAdminStatistiques.pagesConsultees")}
                    labels={labelsPagesConsultees}
                    datasets={datasetsPagesConsultees}
                  />
                </div>
              </Tab>
            </Tabs>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default ModalDetailsVisiteur;
